import type { ReadonlySignal } from "@preact/signals";
import { InputLabel } from "./input-label.js";
import { InputError } from "./input-error.js";
import { inputClass, type FieldProps } from "./shared.js";
import type { FormEmbedField } from "../../types.js";

interface TextareaProps {
  field: FormEmbedField;
  input: ReadonlySignal<any>;
  errors: ReadonlySignal<[string, ...string[]] | null>;
  props: FieldProps;
  disabled: boolean;
}

export function Textarea({ field, input, errors, props, disabled }: TextareaProps) {
  const errorClass = errors.value ? "border-theme-destructive" : "border-theme-input";

  return (
    <div class={`flex flex-col gap-1 ${field.width === "half" ? "w-[calc(50%-6px)]" : "w-full"}`} data-fv-field={field.name}>
      <InputLabel label={field.label} required={field.required} description={field.description} />
      <textarea
        {...props}
        class={`${inputClass} ${errorClass} min-h-[80px] resize-y`}
        placeholder={field.placeholder || "Type your detailed answer..."}
        value={input}
        disabled={disabled}
        aria-invalid={!!errors.value}
        aria-errormessage={`${props.name}-error`}
      />
      <InputError name={props.name} errors={errors} />
    </div>
  );
}
